import { render } from "./VulnPublic.vue?vue&type=template&id=5c1131f5"
import script from "./VulnPublic.vue?vue&type=script&lang=js"
export * from "./VulnPublic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__